import { gql } from '@apollo/client';

const SUMMARY_FIELDS = `
  postId
  question
  description
  status
  respondentCount
  allowMultiple
  allowOther
  isClosed
  closesAt
  createdAt
  publishAt
  streamName
`;

export const GET_POLLS = gql`
  query Polls {
    polls { ${SUMMARY_FIELDS} }
  }
`;

const RESPONDENT_FIELDS = `membershipId name organisationName answers otherText respondedAt`;

export const GET_POLL_RESULTS = gql`
  query PollResults($postId: Int!) {
    pollResults(postId: $postId) {
      poll { ${SUMMARY_FIELDS} }
      options { id label count respondents { ${RESPONDENT_FIELDS} } }
      otherAnswers { ${RESPONDENT_FIELDS} }
      respondents { ${RESPONDENT_FIELDS} }
    }
  }
`;

export const CLOSE_POLL = gql`
  mutation ClosePoll($postId: Int!, $closed: Boolean) {
    closePoll(postId: $postId, closed: $closed) { ${SUMMARY_FIELDS} }
  }
`;
